module.exports = __webpack_public_path__ + "img/dog_12157.75ffef3c.png";